<script>
	import { User } from '../store.js';
	const urlParams = new URLSearchParams(window.location.search);
  const apiToken = urlParams.get('apiToken');
  const calendarObject = JSON.parse(urlParams.get('calendarObject'));

	if(apiToken && calendarObject ){
		User.loginWithToken(apiToken,calendarObject);
	}
	
	let username;
	let password;
	let message;

	let loading = false;
	async function login(){
		loading = true;
		let response = await User.login(username,password);
		loading = false;
		if(typeof(response) === 'string'){
			message = response;
		}
	}
</script>

<main>
	<form class='login-box' on:submit|preventDefault={login}>
		<h2>Login</h2>
		{#if message}
		<p class='error'>{message}</p>
		{/if}
		<p>
			<input type='text' name='username' bind:value={username} placeholder="Email Address" />
		</p>
		<p>
			<input type='password' name='password' bind:value={password} placeholder="Password" />
		</p>
		<button disabled={loading}>Login</button>
		<p class='disclaimer'>I agree to the <a href='https://portals.airbetter.com/assets/files/HOST%20LICENSE%20AGREEMENT.pdf'>terms of use of the Airbetter Host Platform</a> by signing in</p>

	</form>
</main>

<style>
	h2{
		font-weight: normal;
		color: #555;
		font-size:18px;
		text-align: center;
	}
	main{
		display: flex;
		align-items: center;
		justify-content: center;
 		flex-grow: 1;
	}
	.login-box{
		background-color: white;
		padding:5px 30px 25px;
	}
	button{
		color:white;
		background-color: #EF4064;
		width:100%;
	}
	button:hover{
		background-color: #51cbce;
	}
	button:disabled{
		background-color: #333;
		cursor: not-allowed;
	}
	input{
		width:250px;
		font-size:14px;
	}
	.disclaimer{
		width:250px;
		font-size: 10px;
	}
	.error{
		display: block;
		background-color: #FFDFE2;
		padding:10px;
		font-size:11px;
	}
</style>